import { AnyAction } from 'redux';
import ACTION_TYPES from '../actionTypes';

type ExampleState = {
  examples: Example[],
};

const initialState: ExampleState = {
  examples: [],
};

export const exampleReducer = (state = initialState, action: AnyAction): ExampleState => {
  switch (action.type) {
    case ACTION_TYPES.SET_EXAMPLE_DATA: {
      const { payload } = action as setExampleDataAction;

      return {
        ...state,
        examples: payload.examples,
      };
    }
    default: {
      return state;
    }
  }
};
